import { Component, EventEmitter, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router, ActivatedRoute, RouterModule } from "@angular/router";
import { IKeyContact } from "../../../interfaces/ikeycontact";
import { EmitterService } from "../../../services/emitter.service";
import { IButton } from "../../../interfaces/ibuttons";
import { FormGroup, Validators, FormBuilder, FormArray, FormControl } from "@angular/forms";
import { KeyContactService } from "../../../services/keycontact.service";
import { AppSettings } from "../../../appsettings";
import { ToastrService } from "ngx-toastr";
import { SetSelectedBusinessFunctionAction } from "../../../actions/applicationuser.action";
import { Store } from "@ngrx/store";
import { IAppStore } from "../../../iappstore";
import { IBusinessFunction } from "../../../interfaces/ibusinessfunction";
import { HeaderComponent } from "../../header/header.component";

@Component({
    selector: "keycontact",
    templateUrl: "./keycontact.component.html",
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, HeaderComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class KeyContactComponent {

    keyContact: IKeyContact;
    keyContactForm: FormGroup;
    title: string;
    hideDisableUpdates: boolean = true;
    headerButtons: IButton[];

    constructor(private router: Router,
        private activatedRoute: ActivatedRoute,
        private keyContactService: KeyContactService,
            private toastr:ToastrService,
            private store: Store<IAppStore>) {
        const emailRegex: string = AppSettings.emailRegExp.source;
        this.keyContact = activatedRoute.snapshot.data["keyContact"];
        this.keyContactForm = new FormGroup({
            id: new FormControl(this.keyContact ? this.keyContact.id : null),
            businessFunctionId: new FormControl(this.keyContact ? this.keyContact.businessFunctionId : null),
            name: new FormControl(this.keyContact ? this.keyContact.name : "", [Validators.required]),
            email: new FormControl(this.keyContact ? this.keyContact.email : "", [Validators.required, Validators.pattern(emailRegex)]),
            location: new FormControl(this.keyContact ? this.keyContact.location : "", [Validators.required]),
            disabled: new FormControl(this.keyContact ? this.keyContact.disabled : false, [Validators.required])
        });
        this.title = this.keyContact != null
            ? "Edit key contact"
            : "Create key contact";
    }


    save(keyContact: IKeyContact, valid: boolean): void {
        if (valid) {
            let businessFunction: IBusinessFunction;
            this.store.select(e => e.user.selectedBusinessFunction)
            .subscribe((e: IBusinessFunction) => businessFunction = e);

            if (keyContact.id === null || keyContact.id === undefined) {
                this.keyContactService.create(keyContact).subscribe(contact => {
                    // Create a mutable copy of the business function to avoid read-only issues
                    const mutableBusinessFunction = JSON.parse(JSON.stringify(businessFunction));
                    
                    if(!mutableBusinessFunction.keyContacts) {
                        mutableBusinessFunction.keyContacts = new Array<IKeyContact>();
                    }
                    mutableBusinessFunction.keyContacts.push(contact);
                    this.store.dispatch(new SetSelectedBusinessFunctionAction(mutableBusinessFunction));

                    this.toastr.success("The new contact has been saved.");
                    this.router.navigate(["./businessfunction"]);
                });
            } else {
                this.keyContactService.update(keyContact).subscribe(contact => {
                    // Create a mutable copy of the business function to avoid read-only issues
                    const mutableBusinessFunction = JSON.parse(JSON.stringify(businessFunction));
                    
                    this.toastr.success("The key contact has been updated.");
                    let index: number = mutableBusinessFunction.keyContacts.findIndex((e:IKeyContact) => e.id === contact.id);
                    mutableBusinessFunction.keyContacts[index] = contact;
                    this.store.dispatch(new SetSelectedBusinessFunctionAction(mutableBusinessFunction));
                    this.router.navigate(["./businessfunction"]);
                });
            }
        }
    }
}

